/** Days (relative to today) that have a quick-pick chip on the visits screens. */
const CHIP_OFFSETS = [0, -1, 1, 2];

/** Chip value used when the selected date is not one of the quick-pick days. */
export const CUSTOM_DATE_CHIP = 5;

const pad2 = (value) => (value < 10 ? `0${value}` : `${value}`);

/** Formats a Date as YYYY-MM-DD using the local time zone. */
export const formatDateISO = (date = new Date()) =>
  `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;

/** Returns a new Date `days` days away from now (negative = past). */
export const daysFromToday = (days) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};

/** Maps a YYYY-MM-DD string to its chip: -1 yesterday, 0 today, 1 tomorrow, 2 day after, else CUSTOM_DATE_CHIP. */
export const getDateChip = (dateString) => {
  const offset = CHIP_OFFSETS.find(
    (days) => formatDateISO(daysFromToday(days)) === dateString
  );
  return offset === undefined ? CUSTOM_DATE_CHIP : offset;
};

/** Reads an API date: ISO text ("2026-11-02T10:05:00") or the .NET form "/Date(1793612700000)/". Invalid gives null. */
const parseApiDate = (value) => {
  if (value == null || value === "") return null;
  const dotNet = /\/Date\((-?\d+)/.exec(value);
  const date = new Date(dotNet ? Number(dotNet[1]) : value);
  return isNaN(date.getTime()) ? null : date;
};

// Arabic (Iraqi month names) with Latin digits, which read more easily next to the Latin text of the app.
const LOCALE = "ar-IQ-u-nu-latn";

/**
 * Formats an API date for display, e.g. "اليوم · 3:05 م", "أمس · 9:40 ص" or "الأحد، 25 تشرين الأول 2026 · 3:05 م".
 * Gives "" when the value is missing or not a date.
 */
export const formatDateTimeAr = (value) => {
  const date = parseApiDate(value);
  if (!date) return "";
  const time = date.toLocaleTimeString(LOCALE, { hour: "numeric", minute: "2-digit" });
  const day = formatDateISO(date);
  if (day === formatDateISO()) return `اليوم · ${time}`;
  if (day === formatDateISO(daysFromToday(-1))) return `أمس · ${time}`;
  const dateText = date.toLocaleDateString(LOCALE, { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  return `${dateText} · ${time}`;
};

/** Current time formatted for the API (e.g. "3:05:09 PM") in Baghdad time. */
export const currentTimeBaghdad = () =>
  new Date().toLocaleTimeString("en-US", { timeZone: "Asia/Baghdad" });
